import {
  BUSINESS_ACCOUNT_FETCH_CONSENT_DONE,
  BUSINESS_ACCOUNT_FETCH_CONSENT_START,
  BUSINESS_ACCOUNT_FETCH_CONSENT_FAILED,
  BUSINESS_ACCOUNT_FETCH_STATE_DONE,
  BUSINESS_ACCOUNT_FETCH_STATE_START,
  BUSINESS_ACCOUNT_FETCH_STATE_FAILED,
  BUSINESS_ACCOUNT_OPEN_START,
  BUSINESS_ACCOUNT_OPEN_DONE,
  BUSINESS_ACCOUNT_OPEN_FAILED
} from "../actionTypes";

const initialState = {
  firstName: null,
  dateOfBirth: null,
  placeOfBirth: null,
  netbankAgreementsConsented: false,
  firstCircleAgreementsConsented: false,
  openingBusinessAccount: false,
  openBusinessAccountError: null,
  businessAccountEnabled: false,
  businessAccountCreated: false,
  withBusinessAccountConsent: false,
  fetchingBusinessAccountState: false,
  businessAccountStateError: null,
  fetchingBusinessAccountConsent: false,
  businessAccountConsentError: null
}

export default function businessAccount(state = initialState, action) {
  switch (action.type) {
    case BUSINESS_ACCOUNT_FETCH_STATE_START:
      return {
        ...state,
        fetchingBusinessAccountState: true
      }
    case BUSINESS_ACCOUNT_FETCH_STATE_DONE:
      const payload = action.payload;
      return {
        ...state,
        fetchingBusinessAccountState: false,
        firstName: payload.first_name,
        dateOfBirth: payload.date_of_birth,
        placeOfBirth: payload.place_of_birth,
        businessAccountEnabled: payload.supplier_payments_enabled_at != null,
        businessAccountCreated: payload.is_bank_customer,
        withBusinessAccountConsent: payload.is_netbank_consent_valid,
        netbankAgreementsConsented: payload.is_netbank_agreements_consented,
        firstCircleAgreementsConsented: payload.is_first_circle_agreements_consented,
        businessAccountConsentError: null,
        businessAccountStateError: null,
        openBusinessAccountError: null,
      }
    case BUSINESS_ACCOUNT_FETCH_STATE_FAILED:
      return {
        ...state,
        fetchingBusinessAccountState: false,
        businessAccountStateError: action.payload
      }
    case BUSINESS_ACCOUNT_OPEN_START:
      return {
        ...state,
        openingBusinessAccount: true
      }
    case BUSINESS_ACCOUNT_OPEN_DONE:
      return {
        ...state,
        openingBussinessAccount: false,
        businessAccountCreated: true
      }
    case BUSINESS_ACCOUNT_OPEN_FAILED:
      return {
        ...state,
        openingBusinessAccount: false,
        openBusinessAccountError: action.payload
      }
    case BUSINESS_ACCOUNT_FETCH_CONSENT_START:
      return {
        ...state,
        fetchingBusinessAccountConsent: true
      }
    case BUSINESS_ACCOUNT_FETCH_CONSENT_DONE:
      return {
        ...state,
        fetchingBusinessAccountConsent: false,
      }
    case BUSINESS_ACCOUNT_FETCH_CONSENT_FAILED:
      return {
        ...state,
        isfetchingBusinessAccountConsent: false,
        businessAccountConsentError: action.payload
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/features/business_account/reducers/business_account.js